module.exports = __webpack_public_path__ + "img/241.b201fee1.jpg";